// Native
import { Link } from 'react-router-dom'

// Components
import { BreadcrumbItem, BreadcrumbLink, Breadcrumb as ChakraBreadcrumb } from '@chakra-ui/react'

export default function Breadcrumb({ prev = {}, current, ...props }){
    return(
    <ChakraBreadcrumb {...props}>
        <BreadcrumbItem>
            <BreadcrumbLink as={Link} to="/">Home</BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbItem>
            <BreadcrumbLink as={Link} to={prev.path}>{prev.label}</BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbItem isCurrentPage>
            <BreadcrumbLink>{current}</BreadcrumbLink>
        </BreadcrumbItem>
    </ChakraBreadcrumb>
    )
}